import { ILanguageInstance, profileActions } from 'common/modules/ReactShared';
import { I18nContext, locales } from 'i18n';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from 'students/stores/_utils';
import { userSelectors } from 'students/stores/user';
import { useSelect } from '../LanguagesPopup';

interface IReturnType {
  handleSubmit: () => void;
  sortedAllLangs: ILanguageInstance[];
  pickLang: (lanId: string | number) => void;
  pickedLanIds: string[];
}

export function useSupportLanguagesPopup(): IReturnType {
  const dispatch = useDispatch();
  const { locale } = useContext(I18nContext);

  const currentOption = locales.find(({ lKey }) => lKey === locale);

  const sortedAllLangs = useTypedSelector(userSelectors.selectSortedAllLangs);
  const { pick: pickLang, pickedIds: pickedLanIds } = useSelect({
    multiple: false,
    defaultPickedIds: [`${currentOption?.lKey}`]
  });

  const handleSubmit = () => {
    dispatch(
      profileActions.selectStudentSupportLanguage({ mainLanguageId: +pickedLanIds[0] })
    );
  };
  return {
    handleSubmit,
    sortedAllLangs,
    pickLang,
    pickedLanIds
  };
}
